
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCheckboxCheckedFilled as ObiCheckboxCheckedFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-checkbox-checked-filled.js';
 
 
 

 
 export const ObiCheckboxCheckedFilled = createComponent({
   react: React,
   tagName: 'obi-checkbox-checked-filled',
   elementClass: ObiCheckboxCheckedFilledElement,
   events: {
     
   }
  });
 
 